export const API_URL = '/api';
export const AUTH_URL = '/auth';
export const BASE_URL = 'https://drumstores3.herokuapp.com';

// 'http://localhost:8000';
